/**
 * HttpError — Error subclass that carries the HTTP status code from a
 * non-2xx fetch response so callers can branch on the specific status
 * (e.g. 401 → token re-entry, 403 → forbidden view, others → toast).
 */
export class HttpError extends Error {
  public readonly status: number;
  public readonly code?: string;
  /**
   * The daemon's `reason` field, when the error body carries one (409
   * `account_paused` on a queue Resume names the account-wide wall).
   */
  public readonly reason?: string;

  constructor(status: number, message: string, code?: string, extra?: { reason?: string }) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    this.code = code;
    if (extra?.reason !== undefined) this.reason = extra.reason;
    // Maintain proper prototype chain when targeting ES5/older transpilers.
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
